import { styled } from '../jss-style';
import progressStyle from './progress';

const useProgressStyle = styled(progressStyle, 'progress');
export { progressStyle, useProgressStyle };
export default useProgressStyle;
